import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';
import ThemeProvider from 'connect-dot-com-ui-components/theme/ThemeProvider'; // I18n Configuration
// @ts-expect-error Library not migrated yet

import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml'; // @ts-expect-error Library not migrated yet

import registerAllData from 'I18n/init/register/sync/registerAllData'; // @ts-expect-error Library not migrated yet

import { initAppTranslations } from 'I18n/init/setup/AppInit';
import setDocumentTitle from 'I18n/utils/setDocumentTitle'; // Import extra I18n data

import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales'; // Rhumb

import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4'; // Configure the router

import { Router } from 'react-router-dom';
import { getRootUrl } from './utils/urls';
import { Routes } from './components/Routes';
export class App {
  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const I18nProvider = createStandardI18nProvider();
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    I18nProvider.setLocale({
      locale: 'en',
      langEnabled: true
    });
    return langAvailable.then(() => {
      setDocumentTitle('app.htmlTitle');
      this.startRouter();
    });
  }

  startRouter() {
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    render( /*#__PURE__*/_jsx(UIApplication, {
      name: "connect-dot-com-public-ui",
      children: /*#__PURE__*/_jsx(ThemeProvider, {
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          history: historyAdapter(history),
          config: rhumbConfig,
          children: /*#__PURE__*/_jsx(Router, {
            history: history,
            children: /*#__PURE__*/_jsx(Routes, {})
          })
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}